import React, {useState} from "react";
import {Link, Element} from 'react-scroll'
import styles from "../assets/css/services.module.scss";
import {Box, Container, Grid, Hidden, Tab, Tabs, Typography} from "@mui/material";
import "../assets/css/1.css";
import {Link as RouteLink} from "react-router-dom";
import $ from "jquery";
import PropTypes from "prop-types";
import {styled} from '@mui/material/styles';
import configs from '../utils/config.json';

const StyledTabs = styled((props) => (
    <Tabs
        {...props}
        TabIndicatorProps={{children: <span className="MuiTabs-indicatorSpan"/>}}
    />
))({
    '& .MuiTabs-indicator': {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
    '& .MuiTabs-indicatorSpan': {
        maxWidth: 40,
        width: '100%',
        backgroundColor: 'rgb(0, 174, 239)',
    },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
    ({theme}) => ({
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(15),
        marginRight: theme.spacing(1),
        color: '#fff',
        '&.Mui-selected': {
            color: 'rgb(0, 174, 239)',
        },
        '&.Mui-focusVisible': {
            backgroundColor: 'rgba(100, 95, 228, 0.32)',
        },
    }),
);

const Services = (props) => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };



    function TabPanel(props) {
        const {children, value, index, ...other} = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && (
                    <Box sx={{p: 3}}>
                        <Typography>{children}</Typography>
                    </Box>
                )}
            </div>
        );
    }

    TabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }


    const loadVideo = (index) => {
        let video = $("#video1");
        video.attr('src', configs.server.Storage+'/'+props.content[index].video);
        video.load();
        video.play();

    }



    return <>
        <div className={styles.container} id={"services"}>
            <Container maxWidth={"xl"}>

                <Hidden mdDown>
                    <Grid container>
                        <Grid item xs={6} className={styles.itemsContainerParent}>

                            <div className={styles.itemsContainer}>
                                {props.content.map((item, index) => <div style={{display:"flex"}} key={index}>
                                    <div style={{height:"100%",marginTop:"-50vh",width:20}}>
                                        <Element name={`${index}`} key={`ss${index}`} style={{width: "100%",height:"100%"}}>
                                            {/*test 5*/}
                                        </Element>
                                    </div>
                                    <Link className={styles.item} activeClass={styles.activeItem}
                                          to={`${index}`} spy={true} smooth={true}
                                          duration={500}
                                          onSetActive={() => {
                                              loadVideo(index);
                                          }}
                                          style={{display: "flex"}}>

                                        <div style={{height:"fit-content"}}>
                                            <Typography variant={"h6"} component={"h6"}>{item.title}</Typography>
                                            <Typography variant={"body1"} component={"p"} style={{textAlign: "justify"}}>{item.description}</Typography>
                                            <RouteLink to={`/service/${item.id}`}></RouteLink>
                                        </div>

                                    </Link>
                                </div>)}
                            </div>
                        </Grid>
                        <Grid item xs={1} className={styles.elementContainer}>
                            {/*{props.content.map((item, index) =>*/}
                            {/*    <Element name={`${index}`} key={`ss${index}`}>*/}
                            {/*        /!*test 5*!/*/}
                            {/*    </Element>*/}
                            {/*)}*/}
                        </Grid>
                        <Grid item xs={5}>
                            <div className={styles.imageContainer}>
                                <video loop autoPlay muted id={"video1"}/>
                            </div>
                        </Grid>

                    </Grid>
                </Hidden>

                <Hidden mdUp>
                    <div style={{paddingTop:40,paddingBottom:20}}>
                        <StyledTabs value={value} onChange={handleChange} aria-label="basic tabs example"

                                    variant="scrollable"
                                    scrollButtons="auto"
                                    allowScrollButtonsMobile
                                    style={{direction: "ltr"}}>
                            {props.content.map((item, index) => <StyledTab label={item.title} {...a11yProps(index)} key={`${index}`} />)}

                        </StyledTabs>
                        {props.content.map((item, index) => <TabPanel value={value} index={index}  key={`${index}`}>
                            <div>
                                <Typography variant={"body2"} style={{color: "#fff", padding: 10, textAlign: "center"}}>
                                    {item.description}
                                </Typography>
                                <video src={`${configs.server.Storage}/${item.video}`} style={{width: "100%"}} autoPlay muted/>
                            </div>

                        </TabPanel>)}
                    </div>
                </Hidden>
            </Container>

        </div>


    </>;
};

const Item = (props) => {
    return <div style={{display:"flex"}}>
        <div style={{height:"100%",marginTop:"-50vh",width:20}}>
            <Element name={`${props.index}`} key={`ele${props.index}`}>
                {/*test 5*/}
            </Element>
        </div>
        <Link className={styles.item} activeClass={styles.activeItem}
              to={`${props.index}`} spy={true} smooth={true}
              duration={500}
              onSetActive={() => {
                  props.loadVideo(props.index);
              }}
              style={{display: "flex"}}>

            <div style={{height:"fit-content"}}>
                <Typography variant={"h6"} component={"h6"}>{props.title}</Typography>
                <Typography variant={"body1"} component={"p"} style={{textAlign: "justify"}}>{props.description}</Typography>
                <RouteLink to={`/service/${props.id}`}></RouteLink>
            </div>

        </Link>
    </div>
;
};

export default Services;